import countryCodes from "country-codes-list";
import { CircleFlag } from "react-circle-flags";

const CountryDisplay = ({
  country,
  name,
  flag,
}: {
  country?: string;
  name?: boolean;
  flag?: boolean;
}) => {
  const foundCountry = countryCodes
    .all()
    .find((c) => c.countryCode === country);
  const elements = [];
  if (flag && country)
    elements.push(
      <CircleFlag countryCode={country.toLowerCase()} height={30} />
    );
  if (name && foundCountry) elements.push(foundCountry.countryNameEn);
  return <>{elements.join(" ")}</>;
};
export default CountryDisplay;
